class CardTabs {
  constructor(element) {
    this.element = element;
    this.buttons = this.element.querySelectorAll('[data-element="card-tabs-button"]');
    this.contents = this.element.querySelectorAll('[data-element="card-tabs-content"]');
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.buttonOnClick.bind(this, button));
    });
  }

  buttonOnClick(button) {
    const form = this.element.querySelector('[data-element="card-tabs-content"][data-content="' + button.dataset.content + '"]');
    this.setItemActive(button, form);
  }

  setItemActive(button, content) {
    if (button.parentNode.parentNode.classList.contains('is-active')) {
      this.removeAllItemsActive();
      return;
    }

    this.removeAllItemsActive();
    button.closest('.section-row').classList.add('section-row--card-tabs');
    button.parentNode.parentNode.classList.add('is-active');
    button.setAttribute('aria-selected', true);
    content.classList.add('is-active');
  }

  removeAllItemsActive() {
    this.buttons.forEach((button) => {
      button.closest('.section-row').classList.remove('section-row--card-tabs');
      button.parentNode.parentNode.classList.remove('is-active');
      button.setAttribute('aria-selected', false);
    });

    this.contents.forEach((content) => {
      content.classList.remove('is-active');
    });
  }
}

const cardTabs = {
  init() {
    const cardTabsItems = document.querySelectorAll('[data-module="card-tabs"]');

    if (cardTabsItems) {
      cardTabsItems.forEach((item) => {
        const cardTabsItem = new CardTabs(item);
        cardTabsItem.init();
      });
    }
  },
};

export default cardTabs;
